module.exports = __webpack_public_path__ + "static/media/stevejobs_natal.308dcbdd.jpg";